import type { CrawlerTaxonomy } from '@prerender/design-system/CrawlerPicker';

import {
  ACTIVE_CRAWLER_TYPES,
  type CrawlerCategoryScheme,
  crawlerCategoryLabel,
  crawlerType,
  crawlerTypeLabel,
  crawlers,
  isActiveCrawlerType,
} from './Crawlers';

function buildCrawlerTaxonomy(scheme: CrawlerCategoryScheme): CrawlerTaxonomy {
  return {
    typeOrder: ACTIVE_CRAWLER_TYPES,
    typeOf: (category) => {
      const type = crawlerType(category);
      return isActiveCrawlerType(type) ? type : null;
    },
    typeLabel: crawlerTypeLabel,
    categoryLabel: crawlerCategoryLabel,
    searchAliases: (category) => crawlers(category, scheme),
  };
}

const CRAWLER_TAXONOMIES: Record<CrawlerCategoryScheme, CrawlerTaxonomy> = {
  'with-gemini': buildCrawlerTaxonomy('with-gemini'),
  'without-gemini': buildCrawlerTaxonomy('without-gemini'),
};

export function crawlerTaxonomyFor(scheme: CrawlerCategoryScheme): CrawlerTaxonomy {
  return CRAWLER_TAXONOMIES[scheme];
}
